import styled from 'styled-components';

const flexValues = {
    between: 'space-between',
    around: 'space-around',
    evenly: 'space-evenly',
    start: 'flex-start',
    end: 'flex-end',
    center: 'center',
    stretch: 'stretch',
    baseline: 'baseline',
};

interface IFlex {
    align?: 'center' | 'start' | 'end' | 'stretch' | 'baseline';
    justify?: 'between' | 'around' | 'evenly' | 'start' | 'end' | 'center' | 'stretch';
    column?: boolean;
    $wrap?: boolean;
    $grow?: number;
    /** Sets flex-shrink. Has to be a string for it to be usable with '0' as a value. */
    $shrink?: string;
    $reverse?: boolean;
    gap?: string;
    height?: string;
    width?: string;
}

const Flex = styled.div<IFlex>`
  display: flex;
  ${({ column, $reverse }) =>
      (column || $reverse) && `flex-direction: ${column ? ($reverse ? 'column-reverse' : 'column') : 'row-reverse'};`}
  ${({ align }) => align && `align-items: ${flexValues[align]};`}
  ${({ justify }) => justify && `justify-content: ${flexValues[justify]}`};
  ${({ $wrap }) => $wrap && `flex-wrap: wrap`};
  ${({ $grow }) => $grow && `flex-grow: ${$grow}`};
  ${({ $shrink }) => $shrink && `flex-shrink: ${$shrink}`};
  ${({ gap }) => gap && `gap: ${gap}`};
  ${({ height }) => height && `height: ${height}`};
  ${({ width }) => width && `width: ${width}`};
`;

export default Flex;
